module.exports = __webpack_public_path__ + "img/V-R-6-load-connect-shadow.6575325e.png";